import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("cl_lang") || "en");

  useEffect(() => {
    localStorage.setItem("cl_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (code) => setLangState(code);

  const dict = translations[lang] || translations.en;
  const t = (key) => dict[key] ?? translations.en[key] ?? key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
